export default function Header() {
  return (
    <div className="header">
        <h1>UK Earthquakes (2000-2025)</h1>
    </div>
  )
}
